document.addEventListener("DOMContentLoaded", function () {
  const pills = document.querySelectorAll(".pill");
  const pillImagesAndText = document.querySelectorAll(
    ".pills-images-and-text-content"
  );
  const containers = document.querySelectorAll(
    ".pills-images-and-text .video-container"
  );

  pillImagesAndText.forEach((content) => {
    const steps = content.querySelectorAll(".step");

    steps.forEach((step) => {
      step.addEventListener("click", function () {
        steps.forEach((s) => s.classList.remove("active"));
        step.classList.add("active");

        const dataImage = step.dataset.image;
        const dataVideo = step.dataset.video;
        const imageElements = content.querySelectorAll(".image");
        const videoContainers = content.querySelectorAll(".video-container");

        imageElements.forEach((image) => {
          image.classList.remove("active");
          if (image.classList.contains(dataImage)) {
            image.classList.add("active");
          }
        });

        videoContainers.forEach((videoContainer) => {
          videoContainer.classList.remove("active");
          if (videoContainer.classList.contains(dataVideo)) {
            videoContainer.classList.add("active");
          }
        });
      });
    });
  });

  pills.forEach((pill) => {
    pill.addEventListener("click", function () {
      pills.forEach((p) => p.classList.remove("active"));
      pill.classList.add("active");

      const pillName = pill.dataset.name;

      pillImagesAndText.forEach((content) => {
        content.classList.remove("active");
        if (content.classList.contains(pillName)) {
          content.classList.add("active");
        }
      });
    });
  });

  containers.forEach((container) => {
    const video = container.querySelector("video");
    const svg = container.querySelector("svg");
    if (!video || !svg) return;

    container.addEventListener("click", (e) => {
      const clickedVideo =
        e.target === video || e.target.closest("video") === video;
      const clickedSvg = !!e.target.closest("svg");
      if (!clickedVideo && !clickedSvg) return;

      if (video.paused) {
        video.play();
        svg.classList.add("hidden");
      } else {
        video.pause();
        svg.classList.remove("hidden");
      }
    });

    document.addEventListener("click", (e) => {
      if (!container.contains(e.target) && !video.paused) {
        video.pause();
        svg.classList.remove("hidden");
      }
    });
  });
});
